import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
   providedIn: 'root',
})
export class MatIconService {
   readonly icons: string[] = ['sun', 'moon', 'ghost', 'whatsapp'];

   constructor(
      private matIconRegistry: MatIconRegistry,
      private domSanitizer: DomSanitizer
   ) {
      for (const icon of this.icons) {
         this.matIconRegistry.addSvgIcon(
            icon,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${icon}.svg`)
         );
      }
   }
}
